import { DictTranslationLanguagesQueryRes } from '../../../../services/configsData/configsData.service';
import { ITranslation } from './translation.popup';

export const preprocessTranslations = (
  languages: DictTranslationLanguagesQueryRes,
  translations: ITranslation[],
): ITranslation[] => {
  const byId = new Map(translations.map((x) => [x.languageId, x.content] as const));
  return languages.map((lng) => ({
    languageId: lng.id,
    content: byId.get(lng.id) ?? '',
  }));
};

export const postprocessTranslations = (translations: ITranslation[]): ITranslation[] => {
  return translations.filter((translation) => translation.content !== '');
};

const getDisplayNames = (i18nLanguage: string) => {
  return {
    language: new Intl.DisplayNames(i18nLanguage, { type: 'language', languageDisplay: 'dialect' }),
    region: new Intl.DisplayNames(i18nLanguage, { type: 'region' }),
    script: new Intl.DisplayNames(i18nLanguage, { type: 'script' }),
  };
};

const canonicalize = (tag: string): string | null => {
  try {
    return Intl.getCanonicalLocales([tag])[0];
  } catch {
    return null;
  }
};

export const localizedLabelForBCP47Tag = (tag: string, i18nLanguage: string): string => {
  const canonical = canonicalize(tag);

  if (!canonical) return tag;

  const loc = new Intl.Locale(canonical);
  const { language } = getDisplayNames(i18nLanguage);
  const generic = language.of(loc.language);
  return generic || canonical;
};
